import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManualInventoryEntry = () => {
  const [formData, setFormData] = useState({
    category: 'furniture',
    item_type: '',
    brand: '',
    model: '',
    serial_number: '',
    quantity: 1,
    condition: 'New',
    staff_id: '',
    notes: '',
    description: ''
  });

  const [furnitureTypes, setFurnitureTypes] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadFurnitureTypes();
    loadStaff();
  }, []);

  const loadFurnitureTypes = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/furniture-types`);
      setFurnitureTypes(response.data);
    } catch (error) {
      console.error('Error loading furniture types:', error);
    }
  };

  const loadStaff = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/staff?clientCode=caam`);
      setStaffList(response.data);
    } catch (error) {
      console.error('Error loading staff:', error);
    }
  };

  const getFilteredTypes = () => {
    if (formData.category === 'furniture') {
      return furnitureTypes.filter(type => 
        !['Computer', 'Keyboard', 'Mouse', 'Monitor', 'Printer'].includes(type.name)
      );
    } else if (formData.category === 'computer') {
      return furnitureTypes.filter(type => 
        ['Computer', 'Keyboard', 'Mouse', 'Monitor', 'Printer'].includes(type.name)
      );
    }
    return furnitureTypes;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const userStr = localStorage.getItem("user"); const user = userStr && userStr !== "undefined" ? JSON.parse(userStr) : null;
      const payload = {
        ...formData,
        clientCode: 'caam',
        created_by: user?.id
      };

      await axios.post(`${process.env.REACT_APP_API_URL}/inventory-items`, payload);

      setMessage({ type: 'success', text: 'Item added successfully!' });
      
      setFormData({
        category: 'furniture',
        item_type: '',
        brand: '',
        model: '',
        serial_number: '',
        quantity: 1,
        condition: 'New',
        staff_id: '',
        notes: '',
        description: ''
      });
    } catch (error) {
      console.error('Error adding item:', error);
      setMessage({ type: 'error', text: 'Failed to add item. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div style={{
        background: '#ffffff',
        border: '1px solid #e5e5e5',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          marginBottom: '24px',
          color: '#000000'
        }}>
          Add Inventory Item
        </h2>

        {message.text && (
          <div style={{
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '24px',
            background: message.type === 'success' ? '#d1fae5' : '#fee2e2',
            color: message.type === 'success' ? '#065f46' : '#991b1b',
            fontSize: '14px'
          }}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
            
            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Category *
              </label>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              >
                <option value="furniture">Furniture</option>
                <option value="computer">Computer</option>
                <option value="equipment">Equipment</option>
              </select>
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Item Type *
              </label>
              <select
                name="item_type"
                value={formData.item_type}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              >
                <option value="">Select type...</option>
                {getFilteredTypes().map(type => (
                  <option key={type.id} value={type.name}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Description *
              </label>
              <input
                type="text"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                placeholder="e.g., L-Shaped Executive Desk with Built-in Storage"
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Brand
              </label>
              <input
                type="text"
                name="brand"
                value={formData.brand}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Model
              </label>
              <input
                type="text"
                name="model"
                value={formData.model}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Serial Number
              </label>
              <input
                type="text"
                name="serial_number"
                value={formData.serial_number}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Condition *
              </label>
              <select
                name="condition"
                value={formData.condition}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              >
                <option value="New">New</option>
                <option value="Good">Good</option>
                <option value="Fair">Fair</option>
                <option value="Poor">Poor</option>
              </select>
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Quantity *
              </label>
              <input
                type="number"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                min="1"
                required
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Assigned To
              </label>
              <select
                name="staff_id"
                value={formData.staff_id}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000'
                }}
              >
                <option value="">Unassigned</option>
                {staffList.map(staff => (
                  <option key={staff.id} value={staff.id}>
                    {staff.first_name} {staff.last_name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ gridColumn: '1 / -1' }}>
              <label style={{
                display: 'block',
                fontSize: '13px',
                fontWeight: '600',
                color: '#404040',
                marginBottom: '6px'
              }}>
                Notes
              </label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows="3"
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  border: '1px solid #d4d4d4',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: '#ffffff',
                  color: '#000000',
                  fontFamily: 'inherit',
                  resize: 'vertical'
                }}
              />
            </div>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '12px', 
            marginTop: '32px',
            paddingTop: '24px',
            borderTop: '1px solid #e5e5e5'
          }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '12px 24px',
                background: '#000000',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Adding...' : 'Add Item'}
            </button>
            <button
              type="button"
              onClick={() => setFormData({
                category: 'furniture',
                item_type: '',
                brand: '',
                model: '',
                serial_number: '',
                quantity: 1,
                condition: 'New',
                staff_id: '',
                notes: '',
                description: ''
              })}
              style={{
                padding: '12px 24px',
                background: '#ffffff',
                color: '#404040',
                border: '1px solid #d4d4d4',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Clear
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManualInventoryEntry;
